"use strict";
'use es6'; // Properties here should be immutable and never change when fetched via upgrade catalog
// If there is a property that might change (e.g. currency), it should be fetched via that endpoint

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var Features = _interopRequireWildcard(require("self-service-api/constants/_MerchandiseFeatures"));

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var BillingNameKeys = _interopRequireWildcard(require("self-service-api/constants/BillingNameKeys"));

var _HighlightedMerchBizObjectives = _interopRequireDefault(require("self-service-api/constants/HighlightedMerchBizObjectives"));

var _ChargeTypes = require("self-service-api/constants/ChargeTypes");

var _ObjectDefaults = require("self-service-api/constants/ObjectDefaults");

var _MerchandiseMap;

var MerchandiseMap = (_MerchandiseMap = {}, (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_CRM, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'CRM',
  parcels: [{
    parcelName: 'sales',
    parcelVersion: 1
  }, {
    parcelName: 'hubspot-free',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'CRM',
  features: Features._crmFeatureIds,
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_FREE, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Free',
  parcels: [{
    parcelName: 'marketing-free-2016',
    parcelVersion: 1
  }, {
    parcelName: 'hubspot-free',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Free marketing tools',
  features: Features._marketingFreeFeatureIds,
  bizObjectives: [],
  edition: Editions.FREE,
  includedAdditionalUnits: 1000000
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Starter',
  parcels: [{
    parcelName: 'marketing-starter-2016',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-starter',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Marketing Starter',
  bizObjectives: [],
  edition: Editions.STARTER,
  includedAdditionalUnits: 1000000
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Hub Starter',
  parcels: [{
    parcelName: 'marketing-starter-2018',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-starter',
    parcelVersion: 2
  }],
  quantityMultiplier: null,
  productName: 'Marketing Hub Starter',
  billingNameKey: BillingNameKeys.MARKETING_STARTER,
  features: Features._marketingStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL],
  edition: Editions.STARTER,
  includedAdditionalUnits: 1000,
  maxAdditionalUnits: 100000,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Hub Starter Contacts',
  parcels: [{
    parcelName: 'additional-contacts-and-emails-5x',
    parcelVersion: 1
  }],
  quantityMultiplier: 1000,
  productName: 'Marketing Hub Starter Contacts',
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_BASIC, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Basic',
  parcels: [{
    parcelName: 'marketing-basic-2011',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-basic-2012',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-basic-2013',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Marketing Hub Basic',
  bizObjectives: [],
  includedAdditionalUnits: 100,
  maxAdditionalUnits: 15000,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_MARKETING_BASIC_CONTACTS
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_BASIC_CONTACTS, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Basic Contacts',
  parcels: [],
  quantityMultiplier: 1000,
  productName: 'Marketing Hub Basic Contacts',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Professional',
  parcels: [{
    parcelName: 'marketing-pro-2011',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-pro-2012',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-pro-2013',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Marketing Hub Professional',
  billingNameKey: BillingNameKeys.MARKETING_PROFESSIONAL,
  features: Features._marketingProfessionalFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL],
  edition: Editions.PROFESSIONAL,
  includedAdditionalUnits: 1000,
  maxAdditionalUnits: 60000,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS,
  requiredOnboardingMerchId: MerchandiseIds.SERVICE_MARKETING_PROFESSIONAL_ONBOARDING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Professional Contacts',
  parcels: [],
  quantityMultiplier: 1000,
  productName: 'Marketing Hub Professional Contacts',
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Enterprise',
  parcels: [{
    parcelName: 'marketing-ent-2011',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-ent-2012',
    parcelVersion: 1
  }, {
    parcelName: 'marketing-ent-2013',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Marketing Hub Enterprise',
  billingNameKey: BillingNameKeys.MARKETING_ENTERPRISE,
  features: Features._marketingEnterpriseFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE],
  edition: Editions.ENTERPRISE,
  includedAdditionalUnits: 10000,
  maxAdditionalUnits: 500000,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_CONTACTS,
  requiredOnboardingMerchId: MerchandiseIds.SERVICE_MARKETING_ENTERPRISE_ONBOARDING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_CONTACTS, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Marketing Enterprise Contacts',
  parcels: [],
  quantityMultiplier: 1000,
  productName: 'Marketing Hub Enterprise Contacts',
  billingNameKey: BillingNameKeys.ADDITIONAL_CONTACTS,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_FREE, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Sales Free',
  parcels: [{
    parcelName: 'sales',
    parcelVersion: 1
  }, {
    parcelName: 'hubspot-free',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Free sales tools',
  features: Features._salesFreeFeatureIds,
  bizObjectives: [],
  edition: Editions.FREE
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PRO_LEGACY, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Sales Pro Legacy',
  parcels: [{
    parcelName: 'sales-pro',
    parcelVersion: 1
  }],
  quantityMultiplier: 1,
  productName: 'Sales Hub Professional',
  activelySold: false,
  features: {},
  bizObjectives: [],
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SALES_PRO_LEGACY
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PRO_BUSINESS_USER, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Sales Pro Business User',
  parcels: [{
    parcelName: 'sales-pro',
    parcelVersion: 1
  }],
  quantityMultiplier: 1,
  productName: 'Sales Hub Professional',
  activelySold: false,
  features: {},
  bizObjectives: [],
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SALES_PRO_BUSINESS_USER
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_STARTER, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Sales Starter',
  parcels: [{
    parcelName: 'sales-starter',
    parcelVersion: 1
  }],
  quantityMultiplier: 1,
  productName: 'Sales Hub Starter',
  billingNameKey: BillingNameKeys.SALES_STARTER,
  features: Features._salesStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SALES_STARTER],
  edition: Editions.STARTER,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SALES_STARTER,
  includedAdditionalUnits: 1
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Sales Professional',
  // Sales Pro users are grandfathered into Sales Professional.
  parcels: [{
    parcelName: 'sales-pro-bundle',
    parcelVersion: 1
  }, {
    parcelName: 'sales-pro',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Sales Hub Professional',
  billingNameKey: BillingNameKeys.SALES_PROFESSIONAL,
  features: Features._salesProfessionalFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SALES_PROFESSIONAL],
  edition: Editions.PROFESSIONAL,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER,
  includedAdditionalUnits: 5,
  requiredOnboardingMerchId: MerchandiseIds.SERVICE_QUICK_START_CONSULTATION
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Sales Professional Additional Users',
  parcels: [{
    parcelName: 'sales-pro-additional-seat',
    parcelVersion: 1
  }],
  quantityMultiplier: 1,
  productName: 'Sales Hub Professional Additional User',
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: [],
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_ENTERPRISE, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Sales Enterprise',
  parcels: [{
    parcelName: 'sales-enterprise-bundle',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Sales Hub Enterprise',
  billingNameKey: BillingNameKeys.SALES_ENTERPRISE,
  features: Features._salesEnterpriseFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SALES_ENTERPRISE],
  edition: Editions.ENTERPRISE,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER,
  includedAdditionalUnits: 10,
  requiredOnboardingMerchId: MerchandiseIds.SERVICE_SALES_ENTERPRISE_ONBOARDING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Sales Enterprise Additional Users',
  parcels: [{
    parcelName: 'sales-enterprise-additional-seat',
    parcelVersion: 1
  }],
  quantityMultiplier: 1,
  productName: 'Sales Hub Enterprise Additional User',
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: [],
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_FREE, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Service Free',
  parcels: [{
    parcelName: 'service-free',
    parcelVersion: 1
  }, {
    parcelName: 'hubspot-free',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Free service tools',
  features: Features._serviceFreeFeatureIds,
  bizObjectives: [],
  edition: Editions.FREE
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_STARTER, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Service Starter',
  parcels: [{
    parcelName: 'service-starter',
    parcelVersion: 1
  }],
  quantityMultiplier: 1,
  productName: 'Service Hub Starter',
  billingNameKey: BillingNameKeys.SERVICE_STARTER,
  features: Features._serviceStarterFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SERVICE_STARTER],
  edition: Editions.STARTER,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SERVICE_STARTER,
  includedAdditionalUnits: 1
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Service Professional',
  parcels: [{
    parcelName: 'service-professional-bundle',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Service Hub Professional',
  billingNameKey: BillingNameKeys.SERVICE_PROFESSIONAL,
  features: Features._serviceProfessionalFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL],
  edition: Editions.PROFESSIONAL,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER,
  includedAdditionalUnits: 5,
  requiredOnboardingMerchId: MerchandiseIds.SERVICE_QUICK_START_CONSULTATION
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Service Professional Additional User',
  parcels: [{
    parcelName: 'service-professional-additional-seat',
    parcelVersion: 1
  }],
  quantityMultiplier: 1,
  productName: 'Service Hub Professional Additional User',
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: [],
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Professional Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Service Professional Onboarding',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Service Enterprise',
  parcels: [{
    parcelName: 'service-enterprise-bundle',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Service Hub Enterprise',
  billingNameKey: BillingNameKeys.SERVICE_ENTERPRISE,
  features: Features._serviceEnterpriseFeatureIds,
  bizObjectives: _HighlightedMerchBizObjectives.default[MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE],
  edition: Editions.ENTERPRISE,
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER,
  includedAdditionalUnits: 10,
  requiredOnboardingMerchId: MerchandiseIds.SERVICE_SERVICE_ENTERPRISE_ONBOARDING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Service Enterprise Additional Users',
  parcels: [{
    parcelName: 'service-enterprise-additional-seat',
    parcelVersion: 1
  }],
  quantityMultiplier: 1,
  productName: 'Service Hub Enterprise Additional User',
  billingNameKey: BillingNameKeys.ADDITIONAL_USERS,
  features: {},
  bizObjectives: [],
  additionalUnitMerchId: MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SERVICE_ENTERPRISE_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Enterprise Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Service Enterprise Onboarding',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SERVICE_ENTERPRISE_ONBOARDING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_API, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon API',
  parcels: [{
    parcelName: 'api-addon-2016',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'API Add-on',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_API
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_ADS, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Ads',
  parcels: [{
    parcelName: 'ads',
    parcelVersion: 1
  }, {
    parcelName: 'ads-grandfathered',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Ads Add-on',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_ADS
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_ADS_CAPACITY, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Ads Dec 2018',
  parcels: [{
    parcelName: 'ads-add-on',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Ads Add-on Dec 2018',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_MARKETING_BASIC_WITH_PROFEESSIONAL_LIMITS, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Marketing Basic with Professional Limits',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Marketing Basic Add-on with Professional Limits',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_DEDICATED_IP, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Dedicated IP',
  parcels: [{
    parcelName: 'dedicated-ip',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Dedicated IP Add-on',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_DEDICATED_IP
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_REPORTING, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Reporting',
  parcels: [{
    parcelName: 'reporting',
    parcelVersion: 1
  }, {
    parcelName: 'reporting-grandfathered',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Reporting Add-on',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_REPORTING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Transactional Email',
  parcels: [{
    parcelName: 'transactional-email',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Transactional Email Add-on',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_TRANSACTIONAL_EMAIL
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_CUSTOM_SSL, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Custom SSL',
  parcels: [{
    parcelName: 'content-custom-ssl',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Custom SSL Add-on',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_CUSTOM_SSL
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_WEBSITE_STARTER, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Website Starter',
  parcels: [{
    parcelName: 'sites',
    parcelVersion: 1
  }, {
    parcelName: 'sites-basic-2014',
    parcelVersion: 1
  }, {
    parcelName: 'sites-grandfathered',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Website Starter Add-on',
  features: {},
  bizObjectives: [],
  activelySold: false
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_WEBSITE_UNLIMITED, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Website Unlimited',
  parcels: [{
    parcelName: 'sites-unlimited',
    parcelVersion: 1
  }, {
    parcelName: 'sites-unlimited-2014',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Website Unlimited Add-on',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_CMS, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon CMS',
  parcels: [{
    parcelName: 'cms-standalone-paid',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'CMS',
  features: Features._cmsFeatureIds,
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_CMS
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_BRAND_DOMAIN, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Addon Brand Domain',
  parcels: [{
    parcelName: 'additional-brand-domains',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'Brand Domain Add-on',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.ADDON_BRAND_DOMAIN
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.ADDON_CMS_FREE, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Addon CMS Free',
  parcels: [{
    parcelName: 'cms-standalone-free',
    parcelVersion: 1
  }],
  quantityMultiplier: null,
  productName: 'CMS Free',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_FIRST_TEMPLATE_SETUP, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service First-Time Template Setup',
  parcels: [],
  quantityMultiplier: null,
  productName: 'First-Time Template Setup',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TRAINING_MARKETING_FUNDAMENTALS, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Training Marketing Fundamentals',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Marketing Fundamentals Training',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SERVICE_TRAINING_MARKETING_FUNDAMENTALS
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TRAINING_SALES_MARKETING_ALIGNMENT, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Training Sales Marketing Alignment',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Sales & Marketing Alignment Training',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TRAINING_CRM_MANAGEMENT, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Training CRM Management',
  parcels: [],
  quantityMultiplier: null,
  productName: 'CRM Management Training',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TRAINING_AGENCY_ACCOUNT_MANAGEMENT, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Training Agency Account Management',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Agency Account Management Training',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_CONSULTING_AGENCY_PIPELINE, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Consulting Agency Pipeline',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Agency Pipeline Consulting',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_CONSULTING_SALES_SKILLS, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Consulting Sales Skills',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Sales Skills Consulting',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_MARKETING_BASIC_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Marketing Basic Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Marketing Basic Onboarding',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_MARKETING_PROFESSIONAL_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Marketing Professional Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Marketing Professional Onboarding',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.MARKETING_PROFESSIONAL_ONBOARDING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_MARKETING_ENTERPRISE_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Marketing Enterprise Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Marketing Enterprise Onboarding',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.MARKETING_ENTERPRISE_ONBOARDING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_CRM_SALES_STARTER_KIT, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Starter Kit',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Starter Kit',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Sales Professional Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Sales Professional Onboarding',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_SALES_ENTERPRISE_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Sales Enterprise Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Sales Enterprise Onboarding',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SALES_ENTERPRISE_ONBOARDING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONE_DAY, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Inbound Consulting One Day',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Inbound Consulting - One Day',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_INBOUND_CONSULTING_FOUR_HOUR, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Inbound Consulting Four Hour',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Inbound Consulting - Four Hour',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TECH_CONSULTING_ONE_DAY, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Tech Consulting One Day',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Tech Consulting - One Day',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TECH_CONSULTING_FOUR_HOURS, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Tech Consulting Four Hours',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Tech Consulting - Four Hours',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_DESIGNATED_TECHNICAL_SUPPORT, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Designated Technical Support',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Designated Technical Support',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_PROFESSIONAL_SUITE_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Professional Suite Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Professional Suite Onboarding',
  billingNameKey: BillingNameKeys.PROFESSIONAL_SUITE_ONBOARDING,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_ENTERPRISE_SUITE_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Enterprise Suite Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Enterprise Suite Onboarding',
  billingNameKey: BillingNameKeys.ENTERPRISE_SUITE_ONBOARDING,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_CONTENT_PROFESSIONAL_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Service Content Professional Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Content Professional Onboarding',
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'HubSpot for Startups Setup',
  parcels: [],
  quantityMultiplier: null,
  productName: 'HubSpot for Startups Setup',
  billingNameKey: BillingNameKeys.HSFS_SETUP,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_QUICK_START_CONSULTATION, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'Quick Start Consultation',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Quick Start Consultation',
  billingNameKey: BillingNameKeys.QUICK_START_CONSULTATION,
  features: {},
  bizObjectives: []
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_TECHNICAL_CONSULTING_ONGOING, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Technical Consulting: Ongoing',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Technical Consulting: Ongoing',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SERVICE_TECHNICAL_CONSULTING_ONGOING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_INBOUND_CONSULTING_MONTHLY, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Inbound Consulting: Monthly',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Inbound Consulting: Monthly',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SERVICE_INBOUND_CONSULTING_MONTHLY
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONGOING, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Inbound Consulting: Ongoing',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Inbound Consulting: Ongoing',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.SERVICE_INBOUND_CONSULTING_ONGOING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_PREMIUM_CONSULTING, {
  chargeType: _ChargeTypes.RECURRING,
  trackingName: 'Premium Consulting',
  parcels: [],
  quantityMultiplier: null,
  productName: 'Premium Consulting',
  billingNameKey: BillingNameKeys.SERVICE_PREMIUM_CONSULTING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_FIRST_TIME_FULL_MIGRATION, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'First-Time Full Migration',
  parcels: [],
  quantityMultiplier: null,
  productName: 'First-Time Full Migration',
  features: {},
  bizObjectives: [],
  billingNameKey: null,
  additionalUnitMerchId: MerchandiseIds.SERVICE_FIRST_TIME_FULL_MIGRATION
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_LATAM_MARKETING_PROFESSIONAL_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'LatAm Marketing Professional Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'LatAm Marketing Professional Onboarding',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.MARKETING_PROFESSIONAL_ONBOARDING
}), (0, _defineProperty2.default)(_MerchandiseMap, MerchandiseIds.SERVICE_LATAM_MARKETING_ENTERPRISE_ONBOARDING, {
  chargeType: _ChargeTypes.NON_RECURRING,
  trackingName: 'LatAm Marketing Enterprise Onboarding',
  parcels: [],
  quantityMultiplier: null,
  productName: 'LatAm Marketing Enterprise Onboarding',
  features: {},
  bizObjectives: [],
  billingNameKey: BillingNameKeys.MARKETING_ENTERPRISE_ONBOARDING
}), _MerchandiseMap);
var exportedMerchandiseMap = {}; // Add defaults. Defaults overridden by hubMap
// if specified

Object.keys(MerchandiseMap).forEach(function (key) {
  exportedMerchandiseMap[key] = (0, _extends2.default)({}, _ObjectDefaults.MerchandiseObjectDefault, MerchandiseMap[key]);
});
var _default = exportedMerchandiseMap;
exports.default = _default;
module.exports = exports.default;